import { z } from 'zod/v4';

import { unitsOfMeasurementSchema } from '../../../schemas/units-of-measurement.schema';
import { vehicleTypeSchema } from '../../../schemas/vehicle-type.schema';
import { coPilotOptionsSchema } from './copilot-options.schema';
import { costProfileSchema } from './cost-profile.schema';
import { routingOptionsSchema } from './routing-options.schema';
import { vehicleOptionsSchema } from './vehicle-options.schema';

export const routingProfileSchema = z.object({
  routingProfileId: z.number(),
  routingProfileTemplateId: z.number().nullable().optional(),
  name: z.string().min(1),
  isAccountDefault: z.boolean(),
  vehicleType: vehicleTypeSchema,
  units: unitsOfMeasurementSchema,
  vehicleOptions: vehicleOptionsSchema.optional(),
  routingOptions: routingOptionsSchema,
  copilotOptions: coPilotOptionsSchema.optional(),
  vehicleGroups: z
    .array(
      z.object({
        vehicleGroupId: z.number().optional(),
        vehicleGroupName: z.string().optional(),
      })
    )
    .optional(),
  hasCostProfile: z.boolean().optional(),
  costProfiles: z
    .array(
      z.object({
        profile: costProfileSchema,
      })
    )
    .optional(),
});

export type RoutingProfile = z.infer<typeof routingProfileSchema>;
